import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { dataContext } from "../../App";
import landingImg from "../../assets/landingPage/landingPage.jpg";
import newLandingImg from "./assets/campLanding.jpg";
import activityLogSubmission from "../../helper/activitylog";
import styles from "./Campaign2.module.css";
import LoginModalCampaign2 from "../../components/LoginModalCampaign2/LoginModalCampaign2";
import TCModalTournament from "../../components/Modal/TCModalTournament/TCModalTournament";
import OtpModal from "../../components/Modal/OtpModal/OtpModal";
const Campaign2 = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeBottom, setActiveBottom] = useState("campaign");
  const [showLoginModalCampaign, setShowLoginModalCampaign] = useState(false);
  const [showTCModalTournament, setShowTCModalTournament] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const cid = searchParams.get("qcid");
  const {playerData} = useContext(dataContext);
  let navigate = useNavigate();
  if (!cid) {
    navigate("../");
  }
  useEffect(() => {
    let campaignId = null;
    if(searchParams.get('qcid')){
      sessionStorage.setItem('cid', searchParams.get('qcid'));
      campaignId = searchParams.get('qcid');
    }

    setTimeout(() => {
      if(campaignId !== '19'){setShowLoginModalCampaign(true);}
      // just checking commit 
    }, 3000);
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("campaign", msisdn);
    activityLogSubmission("campaign2", msisdn);
  }, []);

  return (
    <>
      <div className={`${styles.landingPage}`}>
        <img src={`https://ms.purplepatch.online/bkash-quiz-banner/camp-banner/new_camp2.jpg`} alt="" srcSet="" className={styles.landingImg} onClick={()=>{
          setShowLoginModalCampaign(true)
        }} />
        <LoginModalCampaign2
          showLoginModalCampaign={showLoginModalCampaign}
          setShowLoginModalCampaign={setShowLoginModalCampaign}
          activeBottom={activeBottom}
          setActiveBottom={setActiveBottom}
          setShowOtpModal={setShowOtpModal}
          showOtpModal={showOtpModal}
        ></LoginModalCampaign2>
      </div>
        {showOtpModal && (
        <OtpModal
          showOtpModal={showOtpModal}
          setShowOtpModal={setShowOtpModal}
          activeBottom={activeBottom}
        ></OtpModal>
      )}
    </>
  );
};

export default Campaign2;
